// eslint-disable-next-line no-unused-vars
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Wrapper from '../../components/wrapper';
import './styles.css';

import {getComponents} from "../utilities";
import Video from "../../blocks/video";
import Promo from "../promo";
import PromoAndButtonModalWindow from '../../blocks/promo-and-button-modal-window';
import * as blocks from "../../blocks";
import Wysiwyg from "../wysiwyg";

/**
 * one column
 * @param {?string} containerId - ブロックにID属性を付与
 * @param {?string} containerClass - ブロックにCLASS属性を付与
 * @param {?string} anchorPoint - ブロックにアンカーを設定（ID属性の値として設定）
 * @param {?string} anchorName - アンカーナビに表示するラベル
 * @param {?string} backgroundColor - 背景色
 * @param {?string} size - 1カラムの場合はGutterを選んでもDividerになる。MBはFull-Width以外の場合はPaddingをつけて表示する（Full-Width / Divider / Vertical-Padding / Gutter / Horizontal-Padding / Padding）
 * @param {?boolean} resetUpperMargin - trueで上付きマージンを解除
 * @param {?boolean} setLowerMargin - trueで下付きマージンを付与
 * @param {?boolean} nested - レイアウトブロックの入れ子の子として設定されている場合はtrueとし、その場合マージンをネストジのマージンとする。通常はfalse。
 * @param {?Array<Component>} components - 1カラム第1コンテンツ。Promo・Video・WYSIWYG・HTMLなどあらゆるブロックを設定可能。複数設定すると上から表示
 * @returns {?ReactElement} `div.OneColumnLayout`
 */
const OneColumnLayout = ({
                           containerId,
                           containerClass,
                           anchorPoint,
                           anchorName,
                           backgroundColor,
                           size,
                           resetUpperMargin,
                           setLowerMargin,
                           nested,
                           components,
                         }) => {
  if (components === null || !Array.isArray(components) || !components.length) {
    return null;
  }

  // ---
  const baseClass = 'OneColumnLayout';
  const sizeClass = `size__${(size || 'Full-Width').toLowerCase()}`;
  const upperMargin = resetUpperMargin ? 'OneColumnLayout__resetUpperMargin': '';
  const lowerMargin = setLowerMargin ? 'OneColumnLayout__setLowerMargin': '';
  const nestedClass = nested ? 'OneColumnLayout__nested': '';
  const classes = [
    baseClass,
    sizeClass,
    upperMargin,
    lowerMargin,
    nestedClass,
  ];
  // ---
  const attributes = {
    className: classes.filter(cssClass => (cssClass)).join(' '),
  };
  // if (backgroundColor) {
  //     attributes.style = { backgroundColor };
  // }
  // ---

  const getNestedComponents = (components, hasBackground = false) => {
    return (
      components.map((component, index) => {
        let name = null;
        if (component.name) {
          name = component.name;
        } else if (component.type) {
          name = component.type.displayName.replace('Connect(', '').replace('withDynamicComponents(', '').replace(')', '').replace(')', '');
          // name = component.type.displayName.replace('withDynamicComponents(', '').replace(')', '');
        }
        if (name === 'Video') {
          return (
            <Video {...component.props}
                   key={index}
                   hasBackground={hasBackground}
                   parentColumn='oneColumnLayout'
            />
          )
        } else if (name === 'Promo') {
          return (
            <Promo {...component.props}
                   key={index}
                   hasBackground={hasBackground}
                   parentColumn='oneColumnLayout'
            />
          )
        } else if (name === 'PromoAndButtonModalWindow') {
          return (
            <PromoAndButtonModalWindow {...component.props}
                   key={index}
                   hasBackground={hasBackground}
                   parentColumn='oneColumnLayout'
            />
          )
        } else if (name === 'Wysiwyg') {
          return (
            <Wysiwyg {...component.props}
                   key={index}
                   parentColumn='oneColumnLayout'
            />
          )
        } else {
          let Block = blocks[name];
          if (Block) {
            return <Block {...component.props} key={index}/>
          } else {
            return null;
          }
        }
      })
    )
  };

  return (
    <Wrapper
      containerId={containerId}
      containerClass={containerClass}
    >
      <div id={anchorPoint} data-anchor-name={anchorName}>
        <div {...attributes}>
          <div className="OneColumnLayout__container">
            <div className="OneColumnLayout__column"
                 style={(backgroundColor && backgroundColor !== '') ? {backgroundColor: backgroundColor}: null}>
              {getNestedComponents(components, (backgroundColor && backgroundColor !== '') ? true : false)}
              {/*{getComponents(components)}*/}
              {/*{components}*/}
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

OneColumnLayout.propTypes = {
  containerId: PropTypes.string,
  containerClass: PropTypes.string,
  anchorPoint: PropTypes.string,
  anchorName: PropTypes.string,
  backgroundColor: PropTypes.string,
  size: PropTypes.string,
  resetUpperMargin: PropTypes.bool,
  setLowerMargin: PropTypes.bool,
  nested: PropTypes.bool,
  components: PropTypes.array,
  // components: PropTypes.arrayOf(PropTypes.node)
};

OneColumnLayout.defaultProps = {
  containerId: null,
  containerClass: null,
  anchorPoint: null,
  anchorName: null,
  backgroundColor: null,
  size: null,
  resetUpperMargin: null,
  setLowerMargin: null,
  nested: null,
  components: null,
};

export default OneColumnLayout;



// WEBPACK FOOTER //
// ./src/containers/one-column-layout/index.jsx